var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "riMobileNavButton", on: { click: _vm.onButtonClick } },
    [
      _c(
        "svg",
        {
          staticClass: "riOpen",
          staticStyle: { width: "56px", height: "56px" },
          attrs: { viewBox: "0 0 56.69 56.69" }
        },
        [
          _c("path", {
            staticStyle: { fill: "#ffffff" },
            attrs: {
              d:
                "M11.34,45.35h34v-6.8h-34Zm0-13.61h34v-6.8h-34Zm0-13.61h34v-6.8h-34Z"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "riClose",
          staticStyle: { width: "56px", height: "56px" },
          attrs: { viewBox: "0 0 56.69 56.69" }
        },
        [
          _c("path", {
            staticStyle: { fill: "#ffffff" },
            attrs: {
              d:
                "M45.35,16,33,28.34,45.35,40.69l-4.66,4.66L28.35,33,16,45.35l-4.69-4.66L23.68,28.34,11.34,16,16,11.34,28.35,23.65,40.69,11.34Z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }